<section [ngClass]="dynamicClass">
    <app-hero-internal *ngIf="CardData?.Image?.value?.src" [data]="CardData"></app-hero-internal>
    <app-breadcrumb *ngIf="breadcrumbData" [data]="breadcrumbData"></app-breadcrumb>
    <!-- Highlights START-->
    <div *ngIf="highlight1 == true || highlight2 == true">
        <section *ngIf="cardTemplateId != '{7610C881-DC37-41BE-A7D1-3FDAB8707B39}'" class="pb-container pb-highlights">
            <div class="pb-flex pb-flex-col lg:pb-flex-row lg:pb-pb-0 pb-pl-0 lg:pb-pl-7 pb-h-full"
                style="background-color: rgba(var(--pb-m-hightlight-background),1); min-height: 100px;">
                <ng-container *ngIf="cardTemplateId == '{3E4BC121-4053-4F44-BAF0-BFA3E1E91EFA}'">
                    <div
                        class="pb-flex pb-flex-col lg:pb-flex-row pb-gap-0 pb-justify-evenly lg:pb-gap-7 xl:pb-gap-11 pb-items-start pb-w-full">
                        <!-- Subscription -->
                        <div *ngIf="CardData.SubscriptionValue?.value"
                            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-text-left pb-border-b last:pb-border-b-0 pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
                            <h2 class="pb-text-xs lg:pb-mb-1 pb-mb-0 pb-w-1/2 lg:pb-w-auto"
                                *scText="CardData.SubscriptionLabel"></h2>
                            <div class="pb-w-1/2 lg:pb-w-auto">
                                <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold" *scText="CardData.SubscriptionValue"></h3>
                                <p class="pb-text-xs pb-font-bold" *scText="CardData.SubscriptionNote"></p>
                            </div>
                        </div>
                        <!-- MinimumPayment -->
                        <div *ngIf="CardData.MinimumPayment?.value"
                            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-text-left pb-border-b last:pb-border-b-0 pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
                            <h2 class=" pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0"
                                *scText="CardData.MinimumPaymentLabel"></h2>
                            <div class="pb-w-1/2 lg:pb-w-auto">
                                <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
                                    {{CardData.MinimumPayment?.value}}
                                </h3>
                                <p class="pb-text-xs pb-font-bold" *scText="CardData.MinimumPaymentNote"></p>
                            </div>
                        </div>
                        <!-- Rate -->
                        <div *ngIf="CardData.Rate?.value"
                            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-text-left pb-border-b last:pb-border-b-0 pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
                            <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0"
                                *scText="CardData.RateLabel">
                            </h2>
                            <div class="pb-w-1/2 lg:pb-w-auto">
                                <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
                                    {{CardData.Rate?.value}}
                                </h3>
                                <p class="pb-text-xs pb-font-bold" *scText="CardData.RateNote"></p>
                            </div>
                        </div>
                        <!-- Loyalty -->
                        <div *ngIf="CardData.LoyaltyProgram[0]?.fields?.Name?.value"
                            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-border-b last:pb-border-b-0 pb-text-left pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
                            <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0"
                                *scText="CardData.LoyaltyProgramLabel"></h2>
                            <div class="pb-w-1/2 lg:pb-w-auto">
                                <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
                                    {{CardData.LoyaltyProgram[0]?.fields?.Name?.value}}
                                </h3>
                                <p class="pb-text-xs pb-font-bold" *scText="CardData.LoyaltyProgramNote"></p>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="cardTemplateId == '{E8EE6052-D75D-492C-906F-8C83754295CF}'">
                    <div
                        class="pb-flex pb-flex-col lg:pb-flex-row pb-gap-0 lg:pb-gap-7 xl:pb-gap-11 pb-justify-evenly pb-items-start pb-w-full">
                        <!-- DailyLimit -->
                        <div
                            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-text-left pb-border-b last:pb-border-b-0 pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
                            <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0"
                                *scText="CardData.DailyLimitLabel"></h2>
                            <div class="pb-w-1/2 lg:pb-w-auto">
                                <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
                                    {{CardData.DailyLimitValue?.value}}
                                </h3>
                                <p class="pb-text-xs pb-font-bold" *scText="CardData.DailyLimitNote"></p>
                            </div>
                        </div>
                        <!-- PurchasePaymentLimit -->
                        <div
                            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-border-b last:pb-border-b-0 pb-text-left pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
                            <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0"
                                *scText="CardData.PurchasePaymentLimitLabel"></h2>
                            <div class="pb-w-1/2 lg:pb-w-auto">
                                <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold" *scText="CardData.PurchasePaymentLimitValue"></h3>
                                <p class="pb-text-xs pb-font-bold" *scText="CardData.PurchasePaymentLimitNote"></p>
                            </div>
                        </div>
                        <!-- PublicationCosts -->
                        <div
                            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-border-b last:pb-border-b-0 pb-text-left pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
                            <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0"
                                *scText="CardData.PublicationCostsLabel"></h2>
                            <div class="pb-w-1/2 lg:pb-w-auto">
                                <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
                                    {{CardData.PublicationCostsValue?.value}}
                                </h3>
                                <p class="pb-text-xs pb-font-bold" *scText="CardData.PublicationCostsNote"></p>
                            </div>
                        </div>
                        <!-- RechargeCost -->
                        <div
                            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-border-b last:pb-border-b-0 pb-text-left pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
                            <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0"
                                *scText="CardData.RechargeCostLabel"></h2>
                            <div class="pb-w-1/2 lg:pb-w-auto">
                                <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
                                    {{CardData.RechargeCostValue?.value}}
                                </h3>
                                <p class="pb-text-xs pb-font-bold" *scText="CardData.RechargeCostNote"></p>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="pb-block lg:pb-hidden pb-border-b pb-c-highlight-item"></div>
                <div *ngIf="CardData?.HighlightButton?.value?.href"
                    class="lg:pb-w-auto pb-w-11/12 pb-pt-6 lg:pb-pt-0 pb-pb-6 lg:pb-pb-0 lg:pb-block pb-self-center lg:pb-self-auto pb-items-center ">
                    <a hybridHref hreflang="{{language}}" *ngIf="CardData?.OnlineIssueing || cardTemplateId == '{E8EE6052-D75D-492C-906F-8C83754295CF}'" href="{{CardData?.HighlightButton?.value?.href}}" aria-label="#"
                        class="pb-h-full pb-px-5 pb-py-4 pb-space-y-1 pb-bg-link pb-self-center pb-items-center pb-flex pb-justify-between lg:pb-items-start lg:pb-flex-col">
                        <h2 class="pb-hidden lg:pb-block pb-text-xs">{{CardData?.HighlightButton?.value?.title}}</h2>
                        <h3 class="pb-text-h-sm pb-font-bold">{{CardData?.HighlightButton?.value?.text}}</h3>
                        <i class="pb-icon pb-icon-arrow-right lg:pb-text-i-32 pb-text-i-24"></i>
                    </a>
                </div>
            </div>

        </section>
    </div>
    <!-- Highlights END -->
    <!-- Banner-Image-List START -->
    <section class="pb-container">
        <div class="pb-flex pb-flex-col pb-gap-5 lg:pb-gap-6 lg:pb-flex-row-reverse">
            <div class="lg:pb-w-1/2">
                <img offset="100" [defaultImage]="'images/default-image.png' | asset"
                    [lazyLoad]="CardData?.FaceCardImage?.value?.src" *ngIf="!isMobile && !energySave"
                    alt="{{CardData?.FaceCardImage?.value?.alt}}" class="pb-aspect-[4/3] pb-object-cover" />
                <img offset="100" [defaultImage]="'images/default-image.png' | asset"
                    [lazyLoad]="CardData?.FaceCardImage?.value?.src" *ngIf="isMobile && !energySave"
                    alt="{{CardData?.FaceCardImage?.value?.alt}}" class="pb-h-full pb-object-cover" />
                <img offset="100" [defaultImage]="'images/default-image.png' | asset"
                    [lazyLoad]="CardData?.FaceCardImageGreen?.value?.src" *ngIf="!isMobile && energySave"
                    alt="{{CardData?.FaceCardImageGreen?.value?.alt}}"
                    class="pb-aspect-[4/3] pb-object-cover pb-energy-image" />
                <img offset="100" [defaultImage]="'images/default-image.png' | asset"
                    [lazyLoad]="CardData?.FaceCardImageGreen?.value?.src" *ngIf="isMobile && energySave"
                    alt="{{CardData?.FaceCardImageGreen?.value?.alt}}"
                    class="pb-h-full pb-object-cover pb-energy-image !pb-filter-none" />
            </div>
            <div class="pb-flex pb-flex-col lg:pb-gap-8 pb-w-full lg:pb-w-1/2">
                <h2 *ngIf="CardData?.DescriptionTitle?.value" class="pb-text-d-md-m lg:pb-text-d-md pb-font-serif">
                    {{CardData?.DescriptionTitle?.value}}
                </h2>
                <div class="pb-text-md-m lg:pb-text-lg" [innerHTML]="CardData?.ShortDescription?.value"></div>
                <div class="pb-flex pb-flex-col pb-gap-5 pb-icon-list pb-mt-7 lg:pb-mt-0"
                    [innerHTML]="CardData?.KeyFeatures?.value"></div>
                <ng-container *ngIf="CardData?.AnchorTo?.value && CardData?.AnchorId?.value">
                    <!-- <a pageScroll [pageScrollOffset]="120" [pageScrollDuration]="1000"
                        href="#{{CardData?.AnchorId?.value}}" attr.aria-label="{{CardData?.AnchorTo?.value}}"
                        class="items-center pb-flex pb-w-fit pb-mt-5 lg:pb-mt-0 pb-cursor-pointer">
                        <span
                            class="pb-underline pb-text-md-m lg:pb-text-md pb-text-color-brand pb-font-bold">{{CardData?.AnchorTo?.value}}</span>
                    </a> -->

                    <button [pageScrollOffset]="120" [pageScrollDuration]="1000"
                        (click)="scrollToAnchor(CardData?.AnchorId?.value)"
                        class="items-center pb-flex pb-w-fit pb-mt-5 lg:pb-mt-0 pb-cursor-pointer">
                        <span class="pb-link pb-font-bold">
                            {{CardData?.AnchorTo?.value}}
                        </span>
                    </button>
                </ng-container>

                <a *ngIf="rendering.fields?.ModalText?.value && hasModal" href="#ContactForm"
                    aria-label="Open contact form" (click)="openModal($event)"
                    class="pb-link pb-font-bold">{{rendering.fields?.ModalText?.value}}</a>
            </div>
        </div>
    </section>
    <!-- Banner-Image-List END -->
    <!-- <button (click)="lakisRedirect()" class="pb-container">test</button> -->
</section>